import React from 'react';
import PropTypes from 'prop-types';
import { trackGtm } from '../../utils';
import * as styles from './SegmentedControl.module.scss';

const ControlItem = ({ id, value, label, selected, dispatch, dispatchAction }) => (
  <div className={styles.input}>
    <input
      {...{ id, value }}
      name="segmentedControl"
      type="radio"
      checked={selected === value}
      onChange={(event) => {
        trackGtm({
          event: 'segmentedControlSelectItem',
          item: label
        });
        dispatch({ type: dispatchAction, payload: event.target.value });
      }}
    />
    <label htmlFor={id}>{label}</label>
  </div>
);

ControlItem.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  selected: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  dispatchAction: PropTypes.string.isRequired
};

const SegmentedControl = ({ state: { items, selected }, id, ...props }) => {
  if (!items) return null;

  return (
    <div className={styles.container} id={id}>
      {items.map((item) => (
        <ControlItem key={item.id} selected={selected} {...item} {...props} />
      ))}
    </div>
  );
};

export default SegmentedControl;
